import React from "react";
import "./IconButton.scss";

// Components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IonButton } from "@ionic/react";
import ButtonLink from "../ButtonLink";

export default function IconButton(props: any) {
  return (
    <div className={`position-relative ${props.className && props.className} icon-button__container ${props.align && "icon-button__container--" + props.align}`}>
      {props.routerLink ? (
        <ButtonLink
          className={`icon-button ${props.disabled && "icon-button--disabled"} icon-button--${props.type} icon-button--${props.color}`}
          to={!props?.disabled && props.routerLink}
          aria-label={props.tooltip}
        >
          {props.customIcon ? <div>{props.customIcon}</div> : <FontAwesomeIcon icon={props.icon} />}
        </ButtonLink>
      ) : (
        <IonButton
          className={`icon-button ${props.disabled && "icon-button--disabled"} icon-button--${props.type} icon-button--${props.color}`}
          onClick={!props?.disabled && props.onClick}
          aria-label={props.tooltip}
        >
          {props.customIcon ? <div>{props.customIcon}</div> : <FontAwesomeIcon icon={props.icon} />}
        </IonButton>
      )}
      {!props.disabled && <span className="icon-button__tooltip">{props.tooltip}</span>}
    </div>
  );
}
